@if (isVisible()) {
    <div
        [dcBgColor]="isAppLaunch() ? 'oche-orange' : 'flight-blue-gradient'"
        dcGradientDirection="top-to-bottom"
        class="dc-event-overlay fixed left-0 top-0 h-full w-full overflow-hidden py-safe"
        animate.enter="dc-anim-fade-in"
        animate.leave="dc-anim-fade-out"
        [style.--dc-anim-enter-duration.ms]="isAppLaunch() ? 0 : 200"
        [style.--dc-anim-leave-duration.ms]="isAppLaunch() ? 500 : 200">
        @if (!isLandscape()) {
            <!-- Portrait -->
            <div class="mx-auto flex h-full w-full max-w-lg flex-col px-6 py-safe-offset-4">
                @if (showSplashData()) {
                    <!-- Target -->
                    <div
                        class="flex h-[29%] items-center justify-center"
                        animate.enter="dc-anim-fade-in-down"
                        [style.--dc-anim-duration.ms]="1000">
                        <img
                            [src]="
                                darkText()
                                    ? 'assets/images/splash/target.webp'
                                    : 'assets/images/splash/target_white.webp'
                            "
                            class="w-[60%] max-w-[26.25rem] object-contain"
                            alt="Target" />
                    </div>
                }

                <!-- Flight -->
                <div class="flex h-[38%] items-center justify-center">
                    <div class="h-full w-full max-w-[24rem] pb-[6px]">
                        @if (lottieData()) {
                            <dotlottie-webworker
                                [autoplay]="true"
                                class="h-full w-full"
                                canvasClass="w-full h-full"
                                backgroundColor="transparent"
                                [loop]="false"
                                [src]="lottieData()"
                                [useFrameInterpolation]="false"
                                workerId="splash-portrait-lottie"></dotlottie-webworker>
                        }
                    </div>
                </div>

                @if (showSplashData()) {
                    <!-- DartCounter -->
                    <div
                        class="flex h-[33%] items-center justify-center"
                        animate.enter="dc-anim-fade-in-up"
                        [style.--dc-anim-duration.ms]="1000">
                        <img
                            [src]="
                                darkText()
                                    ? 'assets/images/splash/dc_text.webp'
                                    : 'assets/images/splash/dc_text_white.webp'
                            "
                            class="w-[50%] max-w-[22.5rem] object-contain"
                            alt="DartCounter" />
                    </div>
                }
            </div>
        } @else {
            <!-- Landscape -->
            <div class="mx-auto flex h-full w-full max-w-4xl space-x-[2rem] p-safe">
                <!-- Flight -->
                <div class="flex w-[52%] items-center justify-end">
                    @if (lottieData()) {
                        <dotlottie-webworker
                            [autoplay]="true"
                            class="h-[80%] w-[80%]"
                            canvasClass="w-full h-full"
                            backgroundColor="transparent"
                            [loop]="false"
                            [src]="lottieData()"
                            [useFrameInterpolation]="false"
                            workerId="splash-landscape-lottie"></dotlottie-webworker>
                    }
                </div>

                @if (showSplashData()) {
                    <!-- DartCounter Logo -->
                    <div
                        class="flex w-[48%] items-center justify-start"
                        animate.enter="dc-anim-fade-in-right"
                        [style.--dc-anim-duration.ms]="1000">
                        <img
                            [src]="
                                darkText()
                                    ? 'assets/images/splash/ta_dc_logo_stacked.webp'
                                    : 'assets/images/splash/ta_dc_logo_stacked_white.webp'
                            "
                            class="w-1/2 object-contain"
                            alt="Target DartCounter" />
                    </div>
                }
            </div>
        }
    </div>
}
